import { useState } from "react";
import type { Sistema } from "@/api/contrato";
import { useSessao } from "@/sessao/useSessao";
import { useAlterarCobranca, usePlanos } from "@/api/consultas";
import { FalhaDaApi, textoDoErro } from "@/api/problema";
import { Selecao } from "@/componentes/Selecao";
import { ModalDeCadastro } from "@/componentes/ModalDeCadastro";
import { useAvisos } from "@/componentes/Avisos";
import { opcoesDePlano } from "./NovoContrato";

/*
 * O plano padrão do cedente novo, numa aplicação `por_cedente`.
 *
 * Só os disponíveis são opção: o servidor recusa o indisponível com
 * `422 plano_indisponivel`, e oferecê-lo seria convidar ao erro. O "—" remove o
 * padrão (`null`), e aí o cedente novo nasce sem contrato e não emite até o
 * operador abrir um.
 */
export function PlanoPadrao({ sistema, aoFechar }: { sistema: Sistema; aoFechar: () => void }) {
  const { cliente } = useSessao();
  const avisos = useAvisos();
  const { data } = usePlanos(cliente, true);
  const alterar = useAlterarCobranca(cliente, sistema.id);

  const [planoID, setPlanoID] = useState(sistema.cobranca.plano_padrao_cedente?.id ?? "");
  const [erroDoCampo, setErroDoCampo] = useState<string | undefined>(undefined);
  const [erro, setErro] = useState<string | undefined>(undefined);

  function enviar() {
    setErro(undefined);
    setErroDoCampo(undefined);
    alterar.mutate(
      // Só o plano: mandar a modalidade junto, mesmo igual, faria a troca de
      // plano padrão depender da regra de consumo da troca de modalidade.
      { plano_padrao_cedente_id: planoID === "" ? null : planoID },
      {
        onSuccess: () => {
          avisos.feito(planoID === "" ? "Plano padrão removido" : "Plano padrão definido");
          aoFechar();
        },
        onError: (falha) => {
          if (falha instanceof FalhaDaApi && falha.problema?.campo === "plano_padrao_cedente_id") {
            setErroDoCampo(textoDoErro(falha));
          } else {
            setErro(textoDoErro(falha));
          }
        },
      },
    );
  }

  return (
    <ModalDeCadastro
      aberto
      aoFechar={aoFechar}
      titulo="Plano padrão"
      descricao={sistema.nome}
      aoEnviar={enviar}
      enviando={alterar.isPending}
      erro={erro}
      rotuloDeEnvio="Salvar"
    >
      <Selecao
        rotulo="Plano"
        dica="Abre o contrato do cedente novo, pelo painel e pela API."
        opcoes={opcoesDePlano(data?.planos ?? [])}
        value={planoID}
        onChange={(evento) => setPlanoID(evento.target.value)}
        erro={erroDoCampo}
        autoFocus
      />
    </ModalDeCadastro>
  );
}
